// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2JYg0","author":"Table_author__3RWEB","authorImage":"Table_authorImage__290e4","unreadRow":"Table_unreadRow__udHev"};